<template>
  <div class="prefabrication-index">
    <!--    <img alt="banner" src="@/assets/images/smartSite/banner.png" style="width: 100%;" />-->

    <SecondaryBanner
      :height="bannerInfo.height"
      :icon="bannerInfo.iconImage"
      :iconText="bannerInfo.iconText"
      :title="bannerInfo.title"
      :bgImage="bannerInfo.bgImage"
      :videoUrl="bannerInfo.videoUrl"
    />

    <AnchorTabs :tabList="tabList" />

    <div
      id="overview"
      class="content"
      v-scroll-animate="{ animation: 'fadeInUp', delay: 100 }"
    >
      <div class="title">什么是 <span>工业化预制与建造平台</span>？</div>
      <div class="text">
        工业化预制与建造平台遵循ISA95国际标准MES设计，综合运用大数据、云计算、5G、IoT、AI和BIM建造等技术，旨在组织工厂排产、提高生产效率、提升产品质量、减少生产周期，最终实现智能管理、智慧管控，打造「透明工厂」，由「制造」转向「智造」。
      </div>
    </div>

    <div id="solutions" class="cardBox">
      <div
        class="title"
        v-scroll-animate="{ animation: 'fadeInUp', delay: 100 }"
      >
        解决方案有哪些？
      </div>

      <div
        v-for="(item, index) in dataList"
        :key="index"
        class="card"
        v-scroll-animate="{ animation: 'fadeInUp', delay: 100 }"
      >
        <img
          alt="image"
          :src="item.picUrl"
          class="image"
          :style="{ order: index % 2 ? 0 : 1 }"
        />

        <div :style="{ order: index % 2 ? 1 : 0 }">
          <div class="subtitle">{{ item.title }}</div>
          <div class="text text-wrap">{{ item.content }}</div>
        </div>
      </div>
    </div>

    <div id="cooperate">
      <!-- :bgImage="
          require('@/assets/images/intelligentImg/bg-advertising-prefabrication.png')
        " -->
      <ProductGet
        title="根据您的业务需要工业化预制与建造平台！"
        subTitle="狄诺尼智能建造，为您带来一站式设计解决方案"
        :showWhiteBg="true"
        :downLoadBtn="{
          label: '下载产品手册',
          fileUrl: '/download?anchor=manual',
          show: true,
        }"
        :contactBtn="{
          label: '让销售人员联系您',
        }"
      />
    </div>
  </div>
</template>

<script>
import AnchorTabs from "@/components/AnchorTabs.vue";
import picture1 from "@/assets/images/prefabrication/picture1.png";
import picture2 from "@/assets/images/prefabrication/picture2.png";
import picture3 from "@/assets/images/prefabrication/picture3.png";
import picture4 from "@/assets/images/prefabrication/picture4.png";
import picture5 from "@/assets/images/prefabrication/picture5.png";
import picture6 from "@/assets/images/prefabrication/picture6.png";
import picture7 from "@/assets/images/prefabrication/picture7.png";
import picture8 from "@/assets/images/prefabrication/picture8.png";
import ProductGet from "@/components/ProductGet.vue";
import SecondaryBanner from "@/components/SecondaryBanner.vue";
import { prefix } from "@/utils/env";

export default {
  name: "prefabrication",
  props: {},
  components: {
    SecondaryBanner,
    ProductGet,
    AnchorTabs,
  },
  data() {
    return {
      bannerInfo: {
        height: "845px",
        iconImage: require("@/assets/images/prefabrication/logo.png"),
        bgImage: require("@/assets/images/intelligentImg/bg-secondary-banner-management.png"),
        iconText: "工业化预制与建造平台",
        title: "实现了建筑构件的标准化生产、精准化装配与全流程数字化管理",
        // pictureUrl: require("@/assets/images/intelligentImg/bg-secondary-banner-prefabrication-posterImg.png"),
        posterImg: require("@/assets/images/intelligentImg/bg-secondary-banner-prefabrication-posterImg.png"),
        videoUrl: `${prefix}/static/video/prefabrication.mp4`,
      },
      tabList: [
        {
          name: "全部",
          value: "overview",
        },
        {
          name: "解决方案",
          value: "solutions",
        },
        {
          name: "合作",
          value: "cooperate",
        },
      ],
      dataList: [
        {
          title: "柔性化排程",
          content:
            "柔性化排程依托于先进的信息技术，如工业物联网（IIoT）、大数据分析、人工智能（AI）和机器学习算法等。通过部署在生产设备上的传感器，实时采集设备运行状态、生产进度、原材料库存等海量数据，并将这些数据传输至统一的管理平台。基于大数据分析，系统能够精准把握生产流程中的各个环节，包括设备产能、人员技能水平、物料供应周期等详细信息，为排程决策提供坚实的数据基础。",
          picUrl: picture1,
        },
        {
          title: "可视化管理",
          content:
            "利用先进的数字化技术，将生产流程、设备运行、库存情况、质量检测等关键信息，通过直观的图表、动态的看板、实时的监控画面等形式展示出来。管理者与一线员工可即时获取准确数据，快速洞察生产中的异常与瓶颈，从而精准决策，优化资源配置，提高生产效率和产品质量，增强工厂的竞争力与应变能力，使整个生产过程更加透明、高效、可控，引领智能工厂迈向新高度。",
          picUrl: picture2,
        },
        {
          title: "及时化预警",
          content:
            "通过在设备、生产线及管理系统中部署传感器和智能算法，它能够实时采集和分析生产数据，如设备温度、压力、运行速度等。一旦数据偏离正常范围，系统立即发出精准警报，通知相关人员及时处理。这有效避免了设备故障、生产中断及质量问题的恶化，减少了停机时间和损失，提升了生产效率和产品质量，为智能工厂的平稳运作筑牢坚实防线。",
          picUrl: picture3,
        },
        {
          title: "智能仓储",
          content:
            "利用自动化设备如堆垛机、穿梭车等，实现货物的自动存储与检索，大幅提升仓储空间利用率和作业效率。结合物联网技术，对货物的出入库、库存数量等信息实时监控和管理，确保库存数据精准无误。同时，智能仓储系统能与工厂的生产环节无缝对接，依据生产需求自动配送物料，有效降低人力成本，提高供应链的整体响应速度，为智能工厂的高效运转提供有力支撑。",
          picUrl: picture4,
        },
        {
          title: "全流程追溯",
          content:
            "利用物联网、大数据、区块链等技术，为产品打造从原材料采购到生产加工、仓储物流直至销售售后的全生命周期 “身份证”。通过采集各环节关键数据，如原料供应商、生产批次、工艺参数、质检报告等，实现信息的精准存储与快速查询。一旦产品出现问题，可迅速定位根源，精准召回并及时改进，既保障消费者权益，提升品牌信誉，又助企业优化管理流程，增强市场竞争力。",
          picUrl: picture5,
        },
        {
          title: "标准化品质",
          content:
            "利用高精度传感器和智能检测设备实时监测产品参数，将数据与预设的标准值精准比对。从原材料筛选到成品出厂，每个环节严格遵循统一标准，一旦出现偏差，系统自动预警并调整工艺参数。同时，通过大数据分析不断优化标准，持续提升产品品质，使智能工厂的产品在市场上具备高度的一致性和竞争力，赢得客户信赖。",
          picUrl: picture6,
        },
        {
          title: "透明化生产",
          content:
            "借助物联网、大数据等技术，打破信息壁垒。通过在设备、生产线部署传感器，实时采集生产数据，如设备运行状况、产品加工进度、质量参数等，并将这些信息直观呈现于管理平台。从管理层到一线工人，均可随时掌握生产全貌。这不仅能及时发现并解决问题，优化生产流程，提高生产效率，还能增强企业与客户、供应商之间的沟通与信任，让生产过程全方位 “可视”“可控”，提升企业竞争力。",
          picUrl: picture7,
        },
        {
          title: "高效化设备",
          content:
            "集成先进的自动化技术、智能传感与精准控制技术，具备高速、高精度、高稳定性的作业能力，能大幅提升生产效率和产品质量。它们可实现自我诊断与故障预警，减少停机时间。同时，通过工业物联网互联互通，能依据生产需求灵活调整参数和运行模式，与上下游工序紧密协同，使整个生产流程更加流畅高效，为智能工厂创造卓越的经济效益和竞争优势。",
          picUrl: picture8,
        },
      ],
    };
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/common.scss";
.prefabrication-index {
  width: 100%;
  height: 100%;
  background: #fff;
  .content {
    width: 100%;
    // height: 224px;
    padding: 40px calc(50% - 524px);
    display: flex;
    flex-direction: column;
    // opacity: 0;
    gap: 24px;

    .title {
      font-size: 24px;
      color: #000000;
      line-height: 24px;
      > span {
        font-weight: 600;
      }
    }
    .text {
      font-weight: 400;
      font-size: 14px;
      color: #000000;
      line-height: 32px;
      text-align: justify;
      font-style: normal;
      text-indent: 2em;
    }
  }

  .cardBox {
    width: 100%;
    padding: 40px calc(50% - 524px);
    display: flex;
    flex-direction: column;
    gap: 40px;

    .title {
      font-weight: 600;
      font-size: 24px;
      color: #000000;
      line-height: 24px;
      text-align: left;
    }

    .card {
      display: flex;
      opacity: 0;
      gap: 66px;

      .image {
        width: 400px;
        height: 240px;
      }

      .subtitle {
        font-weight: 600;
        font-size: 20px;
        color: #333333;
        line-height: 24px;
        margin-top: 24px;
      }
      .text {
        font-weight: 400;
        font-size: 16px;
        color: #666666;
        line-height: 28px;
        margin-top: 16px;
        text-indent: 2em;
        text-align: justify;
      }
    }
  }
}
</style>
